<template>
    <div>
        <pagamento-detalhar 
            :pagamentosServicos="pagamentosServicos"
            :pagamento="pagamento"
            :mostrarTimeLine="exibirTimeline"
        >
            <template slot="footer" slot-scope="data">
                <app-btn-voltar></app-btn-voltar>
                <btn-certidoes
                    class="ml-2"
                    :pagamento="pagamento"
                    :servicos="pagamentosServicos"
                ></btn-certidoes>
                <historico
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></historico>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <pagamento-aprovar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-reprovar>
                <pagamento-aprovar-com-justificativa
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-com-justificativa>
                <btn-retornar-pagamento
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></btn-retornar-pagamento>
                <pagamento-iniciar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-iniciar-reprovar>
                <btn-prioritario
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></btn-prioritario>
                <btn-especial
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></btn-especial>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="mostrarAnexos = true"
                    v-if="acessoRotaUABS && !mostrarAnexos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <btn-exportar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    class="ml-1"
                ></btn-exportar>
                <pagamento-faturar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-faturar>
                <b-button
                    variant="primary"
                    class="ml-2 mr-1"
                    @click.stop="mostrarTimeline()"
                    >{{ textoBtnTimeline }} Timeline</b-button
                >
                <slot name="finalizacaoFooter" v-bind="data"></slot>
            </template>
        </pagamento-detalhar>
        <pagamento-anexos2
            v-if="acessoRotaUABS && mostrarAnexos"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @fechar="mostrarAnexos = false"
        ></pagamento-anexos2>
        <etapas :etapas="pagamento.etapas">
            <template slot="botoes">
                <slot name="etapasBotoes"></slot>
            </template>
            <template slot="etapaAcoes" slot-scope="data">
                <slot name="etapaAcoes" v-bind="data"></slot>
                <pagamento-desassociar-etapa
                    :pagamento="pagamento"
                    :pagamentoEtapa="data"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                    v-if="mostrarBtnDesassociar"
                ></pagamento-desassociar-etapa>
            </template>
        </etapas>
        <b-card no-body>
            <b-card-header>
                <span class="h5">DESPESAS</span>
            </b-card-header>
            <b-card-body>
                <despesas
                    :despesas="pagamento.despesas"
                >
                    <template slot="botoes">
                        <slot name="despesasBotoes"></slot>
                    </template>
                    <template slot="despesaAcoes" slot-scope="data">
                        <slot name="despesaAcoes" v-bind="data"></slot>
                        <pagamento-desassociar-despesa
                            :pagamento="pagamento"
                            :pagamentoDespesa="data"
                            :pagamentosServicos="pagamentosServicos"
                            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                            class="ml-1"
                            v-if="mostrarBtnDesassociar"
                        ></pagamento-desassociar-despesa>
                    </template>
                </despesas>
            </b-card-body>
        </b-card>
        <pagamento-notas-fiscais
            v-if="temAcessoNotasFiscais"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-notas-fiscais>
        <pagamento-anexos
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-anexos>
    </div>
</template>

<script>
import PagamentoDetalhar from './PagamentoDetalhar'
import Etapas from './../etapas/Etapas2'
import PagamentoAnexos from './PagamentoAnexos'
import PagamentoAnexos2 from './PagamentoAnexos2'
import PagamentoNotasFiscais from './PagamentoNotasFiscais'
import { pagamentoStatus } from './PagamentoStatus'
import PagamentoDesassociarEtapa from './PagamentoDesassociarEtapa'
import PagamentoDesassociarDespesa from './PagamentoDesassociarDespesa'
import PagamentoEnviarParaAnalise from './PagamentoEnviarParaAnalise'
import PagamentoAprovarReprovar from './PagamentoAprovarReprovar'
import Historico from './PagamentoHistorico'
import BtnCertidoes from './BtnCertidoes'
import BtnExportar from './BtnExportar'
import BtnPrioritario from './BtnPrioritario'
import BtnEspecial from './BtnEspecial'
import PagamentoTimeLine from './PagamentoTimeLine'
import Despesas from './../despesas/Despesas2'
import PagamentoIniciarReprovar from './PagamentoIniciarReprovar'
import BtnRetornarPagamento from './BtnRetornarPagamento'
import PagamentoAprovarComJustificativa from './PagamentoAprovarComJustificativa.vue'
import PagamentoFaturar from './PagamentoFaturar'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },
        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarAnexos: false.valueOf,
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    methods: {
        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        },
        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    },

    computed: {
        mostrarBtnDesassociar() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('SGTEC-FORN-PAG-03')
            )
        },

        acessoRotaUABS() {
            return this.$temAcesso('SGTEC-PAG-ANX-00')
                && this.$route.name == 'Sgtec_Uabs_Pagamentos_Detalhar'
        },

        // A secao de notas fiscais aparece para quem lanca (fornecedor) e para quem revisa
        // e fatura (financeiro). Os botoes de inserir/excluir/editar dentro dela tem as
        // proprias regras em PagamentoNotasFiscais.vue.
        temAcessoNotasFiscais() {
            return this.$temAcessoView('SGTEC-FORN-PAG-02')
                || this.$temAcessoView('SGTEC-UFI-PAG-00')
        }
    },

    components: {
        PagamentoDetalhar,
        Etapas,
        PagamentoAnexos,
        PagamentoAnexos2,
        PagamentoNotasFiscais,
        PagamentoDesassociarEtapa,
        PagamentoDesassociarDespesa,
        PagamentoDesassociarDespesa,
        PagamentoEnviarParaAnalise,
        PagamentoAprovarReprovar,
        Historico,
        BtnCertidoes,
        BtnExportar,
        BtnPrioritario,
        BtnEspecial,
        PagamentoTimeLine,
        Despesas,
        PagamentoIniciarReprovar,
        BtnRetornarPagamento,
        PagamentoAprovarComJustificativa,
        PagamentoNotasFiscais,
        PagamentoFaturar
    }
}
</script>
